import $ from 'jquery'
// import Swiper from 'swiper'

export default () => {
  $(() => {
    if (!$('body').hasClass('single-product')) return

    // $('div.product .woocommerce-tabs ul.tabs li').click(e => {
    //   if ($(window).width() < 768) {
    //     console.log(0)
    //     e.stopPropagation()
    //     const $container = $(e.target).closest('[role="tab"]')
    //     const target = $container.attr('aria-controls')
    //     $(`div.product .woocommerce-tabs .panel#${target}`).collapse()
    //   }
    // })

    $('.product-summary .entry-summary form.cart .variations .variation-radios .radio').click(e => {
      e.preventDefault()
      const $container = $(e.target).closest('div.radio')
      if ($container.hasClass('selected')) return

      $container.children('input').prop('checked', true)
      $container.addClass('selected').siblings().removeClass('selected')
    })

    // new Swiper('.product-related .swiper-container', {
    //   loop: true,
    //   slidesPerView: 2,
    //   spaceBetween: 8,
    //   navigation: {
    //     nextEl: '.product-related .swiper-button-next',
    //     prevEl: '.product-related .swiper-button-prev',
    //   },
    //   breakpoints: {
    //     768: {
    //       loop: false,
    //       slidesPerView: 4,
    //       spaceBetween: 16,
    //     }
    //   }
    // })

    $('.product-gallery .extended-information').appendTo('.product-gallery .woocommerce-product-gallery')

    // $('.product-gallery .flex-control-nav.flex-control-thumbs').append('<div class="swiper-container"><div class="swiper-wrapper"></div></div>').append('<div class="swiper-button swiper-button-prev"></div><div class="swiper-button swiper-button-next"></div>')
    // $('.product-gallery .flex-control-nav.flex-control-thumbs > li').addClass('swiper-slide').appendTo($('.product-gallery .flex-control-nav.flex-control-thumbs > .swiper-container > .swiper-wrapper'))
    // new Swiper('.product-gallery .main-thumbnail.swiper-container', {
    //   pagination: {
    //     el: '.product-gallery .swiper-pagination',
    //     // type: 'custom',
    //     // dynamicBullets: true,
    //     // dynamicMainBullets: 3,
    //     // renderCustom: function(swiper, current, total) {
    //     //   let html = ''
    //     //   swiper.slides.map((slide, index) => {
    //     //     const bgUrl = $(slide).data('bgUrl')
    //     //     html += `<span class="swiper-pagination-custom-item swiper-pagination-custom-active-main" index="${index}"><img src="${bgUrl}" /></span>`
    //     //   })
    //     //   return html
    //     // }
    //   },
    //   navigation: {
    //     nextEl: '.product-gallery .swiper-button-next',
    //     prevEl: '.product-gallery .swiper-button-prev',
    //   },
    //   // breakpoints: {
    //   //   768: {
    //   //     dynamicMainBullets: 5
    //   //   }
    //   // }
    // })

    // $(document).on('click', '.product-gallery .swiper-container .swiper-pagination .swiper-pagination-custom-item', e => {
    //   e.preventDefault()
    //   const $container = $(e.target).closest('.swiper-pagination-custom-item')
    //   gallerySwiper.slideTo($container.attr('index'))
    // })
  })
}
